import { useQuery } from "@tanstack/react-query";
import { ApiClientError, apiFetch } from "./client";
import type { Whoami } from "./types";

/**
 * Single source of truth for "is the current user an admin".
 * - Cached for the React Query default stale time
 * - Used by the sidebar (cosmetic) and by the admin shell (gate)
 * - Returns `null` when the user is not an admin or not authenticated;
 *   never throws for those cases (so consumers can branch easily).
 */
export function useWhoami() {
  return useQuery({
    queryKey: ["whoami"],
    queryFn: async (): Promise<Whoami | null> => {
      try {
        return await apiFetch<Whoami>("/whoami");
      } catch (err) {
        if (err instanceof ApiClientError && (err.status === 401 || err.status === 403)) {
          return null;
        }
        throw err;
      }
    },
    staleTime: 5 * 60_000, // session-scoped
    gcTime: Infinity,
    retry: false,
  });
}
